export default __webpack_public_path__ + "static/media/live_classes_eamcet.455cf5c2.png";